export function getResourcesUrl(supportLocal: boolean = true) {
  const env = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  if (supportLocal) {
    if (env === 'localhost') {
      return `${document.location.protocol}://localhost:3001`;
    }
    if (document.location.hostname.startsWith('local.')) {
      return `https://local.getcartwheel.com:3001`;
    }
  }
  return `https://resources${env}.getcartwheel.com/share`;
}
